import { render, staticRenderFns } from "./YouTube.vue?vue&type=template&id=3223b14e&"
import script from "./YouTube.vue?vue&type=script&lang=js&"
export * from "./YouTube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/pp-weberbuero-50965/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3223b14e')) {
      api.createRecord('3223b14e', component.options)
    } else {
      api.reload('3223b14e', component.options)
    }
    module.hot.accept("./YouTube.vue?vue&type=template&id=3223b14e&", function () {
      api.rerender('3223b14e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/YouTube.vue"
export default component.exports